import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`

export const SkeletonBase = styled.div`
  width: ${props => props.$width || '100%'};
  height: ${props => props.$height || '20px'};
  border-radius: ${props => props.$borderRadius || '4px'};
  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
`

export const SkeletonText = styled(SkeletonBase)`
  height: 16px;
`

export const SkeletonTitle = styled(SkeletonBase)`
  height: 28px;
  border-radius: 6px;
`

export const SkeletonBadge = styled(SkeletonBase)`
  width: ${props => props.$width || '120px'};
  height: 32px;
  border-radius: 20px;
`

export const SkeletonButton = styled(SkeletonBase)`
  width: ${props => props.$width || '100%'};
  height: ${props => props.$height || '56px'};
  border-radius: 8px;
`

export const SkeletonSelect = styled(SkeletonBase)`
  width: ${props => props.$width || '100%'};
  height: ${props => props.$height || '48px'};
  border-radius: 8px;
`

export const SkeletonCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  animation: ${pulse} 2s ease-in-out infinite;
`

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => props.$marginBottom || '12px'};
  gap: 16px;
`

export const SkeletonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.$gap || '8px'};
`
